import {useContext, useEffect, useRef} from 'react';
import {InitializeParamsContext} from '../../store/context/context';
import styled from 'styled-components';

const SendQuestion = () => {
    const userName = useContext(InitializeParamsContext).userName;
    const questionFormRef = useRef();

    const Button = styled.div`
        color: white;
        font-size: 13px;
        background-color: #ac0000;
        padding: 11px 18px;
        width: max-content;
    `;

    useEffect(() => {
        const questionForm = questionFormRef.current;

        if (questionForm) {
            questionForm.dataset.paramFio = userName;
        }

        return () => {};
    });

    return (
        <>
            <Button
                ref={questionFormRef}
                href="#"
                data-event="jqm"
                data-name="callback2"
                class="btn btn-default colored"
                data-param-form_id="16"
                title={'Вопрос в техническую поддержку'}
            >
                Задать вопрос, оставить отзыв
            </Button>
        </>
    );
};

export {SendQuestion};
